// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.golf-event-card {
  padding: 24px;
}

.golf-event-card-container {
  width: 100%;
  max-width: 350px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.golf-event-title {
  height: 45px;
  font-weight: 700 !important;
  font-size: 16px !important;
  margin-bottom: 16px !important;
  text-align: left;
  color: #002129;
}

.golf-event-venue-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.golf-event-venue-logo {
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}
.golf-event-venue-logo img {
  max-width: 100%;
  max-height: 100%;
}

.golf-event-venue-details {
  display: flex;
  flex-direction: column;
}

.golf-event-venue-name {
  color: #002129;
  font-size: 16px !important;
  font-weight: 700 !important;
  margin-bottom: 4px !important;
  text-align: left;
}

.golf-event-venue-location {
  font-size: 14px !important;
  color: #002129;
  text-align: left;
}

.golf-event-details {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.golf-event-detail-item {
  margin-right: 24px;
}
.golf-event-detail-item:last-child {
  margin-right: 0;
}

.golf-event-detail-label {
  font-weight: 700 !important;
  font-size: 14px !important;
  margin-bottom: 4px !important;
  text-align: left;
  color: #002129;
}

.golf-event-detail-value {
  font-size: 14px !important;
  color: #002129;
}

.golf-event-card-footer {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.golf-event-button {
  text-transform: none !important;
  border-radius: 6px !important;
  background-color: white !important;
  color: black !important;
  border: 1px solid #ccc !important;
  padding: 8px 12px !important;
  font-size: 12px !important;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.golf-event-button:hover {
  background-color: #f5f5f5 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/GolfLeague/EventsPage/EventsCard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,wCAAA;AACJ;;AAEE;EACE,YAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;AACN;;AAGE;EACE,aAAA;EACA,sBAAA;AAAJ;;AAGE;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAAJ;;AAGE;EACE,kBAAA;AAAJ;AAEI;EACE,eAAA;AAAN;;AAIE;EACE,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAIE;EACE,0BAAA;EACA,cAAA;AADJ;;AAIE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AADJ;;AAIE;EACE,+BAAA;EACA,6BAAA;EACA,kCAAA;EACA,uBAAA;EACA,iCAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,oCAAA;AADN","sourcesContent":[".golf-event-card {\n    padding: 24px;\n  }\n  \n  .golf-event-card-container {\n    width: 100%;\n    max-width: 350px;\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 0 auto;\n    border: 1px solid #e0e0e0;\n    padding: 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .golf-event-title {\n    height: 45px;\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    margin-bottom: 16px !important;\n    text-align: left;\n    color: #002129;\n  }\n  \n  .golf-event-venue-info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .golf-event-venue-logo {\n    width: 65px;\n    height: 65px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 16px;\n    \n    img {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n  \n  .golf-event-venue-details {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .golf-event-venue-name {\n    color: #002129;\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    margin-bottom: 4px !important;\n    text-align: left;\n  }\n  \n  .golf-event-venue-location {\n    font-size: 14px !important;\n    color: #002129;\n    text-align: left;\n  }\n  \n  .golf-event-details {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    margin-bottom: 16px;\n  }\n  \n  .golf-event-detail-item {\n    margin-right: 24px;\n    \n    &:last-child {\n      margin-right: 0;\n    }\n  }\n  \n  .golf-event-detail-label {\n    font-weight: 700 !important;\n    font-size: 14px !important;\n    margin-bottom: 4px !important;\n    text-align: left;\n    color: #002129;\n  }\n  \n  .golf-event-detail-value {\n    font-size: 14px !important;\n    color: #002129;\n  }\n  \n  .golf-event-card-footer {\n    display: flex;\n    justify-content: center;\n    margin-top: 16px;\n  }\n  \n  .golf-event-button {\n    text-transform: none !important;\n    border-radius: 6px !important;\n    background-color: white !important;\n    color: black !important;\n    border: 1px solid #ccc !important;\n    padding: 8px 12px !important;\n    font-size: 12px !important;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    \n    &:hover {\n      background-color: #f5f5f5 !important;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
